// Input validation and sanitization utilities

export function sanitizeText(input: string, maxLength = 200): string {
  return input.trim().slice(0, maxLength);
}

export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 254;
}

export function isValidPassword(password: string): { ok: boolean; message: string } {
  if (password.length < 8) return { ok: false, message: 'Passordet må være minst 8 tegn' };
  if (password.length > 128) return { ok: false, message: 'Passordet er for langt' };
  if (!/[A-Za-z]/.test(password)) return { ok: false, message: 'Passordet må inneholde minst én bokstav' };
  if (!/[0-9]/.test(password)) return { ok: false, message: 'Passordet må inneholde minst ett tall' };
  return { ok: true, message: '' };
}

export function isValidName(name: string): { ok: boolean; message: string } {
  const trimmed = name.trim();
  if (trimmed.length < 2) return { ok: false, message: 'Navnet må være minst 2 tegn' };
  if (trimmed.length > 100) return { ok: false, message: 'Navnet er for langt' };
  return { ok: true, message: '' };
}

export function isValidGroupName(name: string): { ok: boolean; message: string } {
  const trimmed = name.trim();
  if (trimmed.length < 2) return { ok: false, message: 'Gruppenavnet må være minst 2 tegn' };
  if (trimmed.length > 100) return { ok: false, message: 'Gruppenavnet er for langt' };
  return { ok: true, message: '' };
}

export function isValidToolName(name: string): { ok: boolean; message: string } {
  const trimmed = name.trim();
  if (trimmed.length < 2) return { ok: false, message: 'Verktøynavnet må være minst 2 tegn' };
  if (trimmed.length > 100) return { ok: false, message: 'Verktøynavnet er for langt' };
  return { ok: true, message: '' };
}

export function isValidInviteCode(code: string): boolean {
  return /^[A-Z0-9]{6,8}$/.test(code.trim().toUpperCase());
}

export function normalizeItemCode(raw: string): string {
  return raw.trim().toUpperCase().replace(/[^A-Z0-9-]/g, '').slice(0, 12);
}

export function isValidItemCode(code: string): boolean {
  return /^[A-Z0-9-]{1,12}$/.test(code);
}
